<template>
  <vx-card title="DNA Kit">
  <div>
    <div v-if="!dnaKit">No kit</div>
    <div v-else>
      <vs-table data="_">
        <vs-tr v-if="dnaKit.userId">
          <vs-td>User Id:</vs-td>
          <vs-td>{{ dnaKit.userId}}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Kit Id:</vs-td>
          <vs-td>{{ dnaKit.kitId }}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Status:</vs-td>
          <vs-td>{{ dnaKit.status }} - {{ dnaKit.statusDate }}</vs-td>
        </vs-tr>
        <vs-tr v-if="dnaKit.tracking">
          <vs-td>USPS Tracking:</vs-td>
          <vs-td>{{ dnaKit.tracking }}</vs-td>
        </vs-tr>
        <vs-tr v-if="dnaKit.purchasedReports">
          <vs-td>Available Reports:</vs-td>
          <vs-td v-if="dnaKit.purchasedReports.length">{{ dnaKit.purchasedReports.join(", ") }}</vs-td>
          <vs-td v-else>No Purchased Reports</vs-td>
        </vs-tr>
        <vs-tr v-if="dnaKit.traitCount">
          <vs-td>Trait Count:</vs-td>
          <vs-td>{{ dnaKit.traitCount }}</vs-td>
        </vs-tr>
      </vs-table>
    </div>
  </div>
  </vx-card>
</template>

<script>

export default {
  props: ["dnaKit"]
};
</script>
